// state/workspace/workspace.actions.ts
import { createAction, props } from '@ngrx/store';
import { Workspace, CreateWorkspacePayload } from '../../models/workspace.model';

// Load Workspaces
export const loadWorkspaces = createAction(
  '[Workspace] Load Workspaces'
);

export const loadWorkspacesSuccess = createAction(
  '[Workspace] Load Workspaces Success',
  props<{ workspaces: Workspace[] }>()
);

export const loadWorkspacesFailure = createAction(
  '[Workspace] Load Workspaces Failure',
  props<{ error: string }>()
);

// Load Single Workspace
export const loadWorkspaceById = createAction(
  '[Workspace] Load Workspace By Id',
  props<{ id: string; includeFiles?: boolean }>()
);

export const loadWorkspaceByIdSuccess = createAction(
  '[Workspace] Load Workspace By Id Success',
  props<{ workspace: Workspace }>()
);

export const loadWorkspaceByIdFailure = createAction(
  '[Workspace] Load Workspace By Id Failure',
  props<{ error: string }>()
);

// Create Workspace
export const createWorkspace = createAction(
  '[Workspace] Create Workspace',
  props<{ workspace: CreateWorkspacePayload }>()
);

export const createWorkspaceSuccess = createAction(
  '[Workspace] Create Workspace Success',
  props<{ workspace: Workspace }>()
);

export const createWorkspaceFailure = createAction(
  '[Workspace] Create Workspace Failure',
  props<{ error: string }>()
);

// Update Workspace
export const updateWorkspace = createAction(
  '[Workspace] Update Workspace',
  props<{ id: string; changes: Partial<CreateWorkspacePayload> }>()
);

export const updateWorkspaceSuccess = createAction(
  '[Workspace] Update Workspace Success',
  props<{ workspace: Workspace }>()
);

export const updateWorkspaceFailure = createAction(
  '[Workspace] Update Workspace Failure',
  props<{ error: string }>()
);

// Delete Workspace
export const deleteWorkspace = createAction(
  '[Workspace] Delete Workspace',
  props<{ id: string }>()
);

export const deleteWorkspaceSuccess = createAction(
  '[Workspace] Delete Workspace Success',
  props<{ id: string }>()
);

export const deleteWorkspaceFailure = createAction(
  '[Workspace] Delete Workspace Failure',
  props<{ error: string }>()
);

// Select Workspace
export const selectWorkspace = createAction(
  '[Workspace] Select Workspace',
  props<{ workspace: Workspace }>()
);

// Clear Selection
export const clearSelectedWorkspace = createAction(
  '[Workspace] Clear Selected Workspace'
);

// Clear Errors
export const clearWorkspaceError = createAction(
  '[Workspace] Clear Error'
);

// File Upload Actions
export const uploadFilesToWorkspace = createAction(
  '[Workspace] Upload Files to Workspace',
  props<{ workspaceId: string; files: File[] }>()
);

export const uploadFileSuccess = createAction(
  '[Workspace] Upload File Success',
  props<{ workspaceId: string; fileName: string }>()
);

export const uploadFilesComplete = createAction(
  '[Workspace] Upload Files Complete',
  props<{ workspaceId: string; successCount: number; failureCount: number }>()
);

export const uploadFileFailure = createAction(
  '[Workspace] Upload File Failure',
  props<{ workspaceId: string; fileName: string; error: string }>()
);

// File Delete Actions
export const deleteFileFromWorkspace = createAction(
  '[Workspace] Delete File From Workspace',
  props<{ workspaceId: string; fileId: string; fileName: string }>()
);

export const deleteFileSuccess = createAction(
  '[Workspace] Delete File Success',
  props<{ workspaceId: string; fileId: string }>()
);

export const deleteFileFailure = createAction(
  '[Workspace] Delete File Failure',
  props<{ error: string }>()
);
